import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    children: React.ReactNode;
    onClose?: () => void;
}

export function ModalWindowContainer({ children, onClose }: Props) {
    return (
        <div className="bg-white rounded">
            <div className="flex justify-end bg-gray-100 rounded">
                <button onClick={onClose}>
                    <CloseRoundedIcon  />
                </button>
            </div>
            {children}
        </div>
    );
}
